module.exports = __webpack_public_path__ + "img/Good Student Award 6.1b0a374e.png";